import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'
import DataUnavailable from '../../../../../components/DataUnavailable'
import {
  PaginatedResults,
  Submission,
} from '../../../../../services/types/APIResponseType'
import CustomPageNavigator from '../../../../../components/Pagination'
import Checked from '../../../../../assets/checkin.svg'
import Close from '../../../../../assets/chekclose.svg'
import Scanface from '../../../../../assets/scanface.svg'
import emptyCheckin from '@/assets/empty_checkins.svg'
import pendingCheckin from '@/assets/Pending_check.svg'
import '../../RegisteredConsumerDetails.css'

interface CheckInTablePropsType {
  checkInTableData: PaginatedResults[]
  CheckInPending: boolean
  handleFaceVerify: (id: string) => void
  currentPage: number
  itemPerPage: number
  totalItemCount: number
  handlePageChange: (newPage: number) => void
  faceAuthPending: boolean
}

const ConsumerCheckInTable: React.FC<CheckInTablePropsType> = ({
  checkInTableData,
  CheckInPending,
  currentPage,
  itemPerPage,
  handleFaceVerify,
  handlePageChange,
  totalItemCount,
}) => {
  const [, setLoadingId] = useState<string | null>(null)

  const handleManualVerify = (id: string) => {
    setLoadingId(id)
    handleFaceVerify(id)
  }

  const getFormattedAddress = (item: Submission) => {
    let address = ''
    if (item?.street_number) {
      address += item?.street_number + ','
    }
    if (item?.route) {
      address += item?.route + ','
    }
    if (item?.neighborhood) {
      address += item?.neighborhood + ','
    }
    if (item?.sublocality_level_1) {
      address += item?.sublocality_level_1 + ','
    }
    if (item?.sublocality_level_2) {
      address += item?.sublocality_level_2 + ','
    }
    if (item?.city) {
      address += item?.city + ','
    }
    if (item?.state) {
      address += item?.state + ','
    }
    if (item?.country) {
      address += item?.country
    }

    return address
  }

  return (
    <>
      {checkInTableData && checkInTableData.length > 0 && !CheckInPending ? (
        <>
          <div className="responsive-table-scroll mt-8">
            <div className="bg-grad before:rounded-[21px] w-full">
              <table className="table-container reg-consumer-table !mt-0">
                <thead>
                  <tr content="start" className="table-heading row-bg1">
                    <th className="text-start border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                      Requested <br /> Check-in Time
                    </th>
                    <th className="text-start border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                      Actual <br /> Check-in Time
                    </th>
                    <th className="border border-[#d8e4fb33] border-r border-b-[0] border-t-[0] w-32">
                      Check-ins
                    </th>
                    <th className="border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                      Location
                    </th>
                    <th className="border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                      Verified
                    </th>
                    <th className="border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                      Scanned Face
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {checkInTableData?.map(
                    (data: PaginatedResults, index: number) => (
                      <>
                        <tr className={`center-dashed-row`}>
                          <td
                            className="text-center centered-text "
                            key={index}
                            colSpan={6}
                          >
                            <h1>{data?.date}</h1>
                          </td>
                        </tr>

                        {data?.submissions?.map(
                          (item: Submission, idx: number) => (
                            <tr
                              key={idx}
                              className={`${idx % 2 === 0 ? 'rowbg2' : 'row-bg1'}`}
                            >
                              <td className="flex justify-start text-start !table-cell !py-[15px] border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                                {item.checkIn_initiated_time ? (
                                  item.checkIn_initiated_time
                                ) : (
                                  <img src={emptyCheckin} alt="empty" />
                                )}
                              </td>
                              <td className="flex justify-start text-start !table-cell !py-[15px] border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                                {item.checkIn_performed_time ? (
                                  item.checkIn_performed_time
                                ) : (
                                  <img src={emptyCheckin} alt="empty" />
                                )}
                              </td>
                              <td className="text-center !py-[15px] border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                                {item.authentication === 'Pending' ? (
                                  <img
                                    src={pendingCheckin}
                                    alt="pendingcheck"
                                    style={{
                                      width: '30px',
                                      height: '30px',
                                      opacity: '0.5',
                                    }}
                                  />
                                ) : item.authentication === 'Fail' ? (
                                  <div className="reg-consumer-verify-wrapper  !py-[15px]">
                                    <img src={Close} alt="" />
                                  </div>
                                ) : (
                                  <img src={Checked} alt="" />
                                )}
                              </td>
                              <td className="flex text-start !table-cell justify-start !py-[15px] border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                                {getFormattedAddress(item)}
                              </td>
                              <td className="border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                                {item.authentication === 'Pending' ? (
                                  <img
                                    src={pendingCheckin}
                                    alt="pendingcheck"
                                    style={{
                                      width: '30px',
                                      height: '30px',
                                      opacity: '0.5',
                                    }}
                                  />
                                ) : item.authentication === 'Fail' ? (
                                  <div className="reg-consumer-verify-wrapper  !py-[15px]">
                                    <img src={Close} alt="" />
                                    <button
                                      className="view-id"
                                      onClick={() =>
                                        handleManualVerify(item._id)
                                      }
                                    >
                                      Verify Manually
                                    </button>
                                  </div>
                                ) : (
                                  <img src={Checked} alt="" />
                                )}
                              </td>
                              <td className="flex justify-start !py-[15px] border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                                <Button>
                                  <Link
                                    to={`/profile?image=${item.capturedImage}`}
                                  >
                                    <img
                                      src={Scanface}
                                      alt="watch"
                                      className="!h-[46px]"
                                    />
                                  </Link>
                                </Button>
                              </td>
                            </tr>
                          ),
                        )}
                      </>
                    ),
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <CustomPageNavigator
            currentPage={currentPage}
            totalItemCount={totalItemCount}
            limitPerPage={itemPerPage}
            setCurrentPage={handlePageChange}
          />
        </>
      ) : (
        <DataUnavailable description="No record found" />
      )}
    </>
  )
}

export default ConsumerCheckInTable
